import React from 'react'
import routes from '../../router/routes'
import { strings } from '../../../localization/strings'
import { TextField, Button } from '@material-ui/core'
import { resetPasswordAssignment } from '../../../helpers/restHelpers'
import Loader from '../../loaders'
import { passwordRegExp } from '../../../utils/regex'
import Grid from '@material-ui/core/Grid/Grid'

class Component extends React.Component {
    state = {
        loading: false,
        passwordNew: '',
        passwordNewRetry: '',
        showPasswordError: true,
    }

    handleConfirm = () => {
        this.setState({ loading: true })
        resetPasswordAssignment({
            token: this.props.keyParam,
            passwordNew: this.state.passwordNew,
        })
            .then(() =>
                window.showDialog(
                    {
                        title: strings.resetPasswordAssignmentSuccessTitle,
                        message: strings.resetPasswordAssignmentSuccess,
                    },
                    () => this.props.history.replace(routes.logIn.path)
                )
            )
            .catch(() =>
                window.showDialog(
                    {
                        title: null,
                        message: strings.resetPasswordAssignmentFailed,
                    },
                    () => this.props.history.replace(routes.logIn.path)
                )
            )
    }
    render() {
        return (
            <div>
                {!this.state.loading ? null : <Loader />}
                <Grid container>
                    <Grid item xs={1} sm={2} md={4}></Grid>

                    <Grid item xs={10} sm={8} md={4}>
                        <p style={{ textAlign: 'center' }}>
                            {strings.resetPasswordAssignmentDescription}
                        </p>

                        <TextField
                            id="passwordNew"
                            label={strings.resetPasswordAssignmentNew}
                            type={'password'}
                            style={{ minWidth: '100%' }}
                            value={this.state.passwordNew}
                            onChange={(ev) => {
                                if (!passwordRegExp.test(ev.target.value)) {
                                    this.setState({
                                        passwordNew: ev.target.value,
                                        showPasswordError: true,
                                    })
                                } else {
                                    this.setState({
                                        passwordNew: ev.target.value,
                                        showPasswordError: false,
                                    })
                                }
                            }}
                        />
                        <ul
                            style={{
                                color: 'red',
                                fontSize: 14,
                                display: this.state.showPasswordError
                                    ? 'inherit'
                                    : 'none',
                                paddingLeft: '1em',
                                fontStyle: 'italic',
                            }}
                        >
                            <li>{strings.passwordLengthHint}</li>
                            <li>{strings.passwordUpperCaseHint}</li>
                            <li>{strings.passwordLowerCaseHint}</li>
                            <li>{strings.passwordNumberHint}</li>
                        </ul>
                        <TextField
                            id="passwordNewRetry"
                            style={{ minWidth: '100%', marginTop: '20px' }}
                            label={strings.resetPasswordAssignmentNewRetry}
                            type={'password'}
                            value={this.state.passwordNewRetry}
                            onChange={(ev) =>
                                this.setState({
                                    passwordNewRetry: ev.target.value,
                                })
                            }
                        />

                        <div className={'centered-element-container'}>
                            <Button
                                disabled={
                                    !(
                                        !!this.state.passwordNew &&
                                        this.state.passwordNew ===
                                            this.state.passwordNewRetry
                                    )
                                }
                                onClick={this.handleConfirm}
                                variant="contained"
                                color="primary"
                            >
                                {strings.resetPasswordAssignmentConfirm}
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default Component
